import { trace } from "owa-trace";
import type FolderTreeData from "../store/schema/FolderTreeData";
import getStore from "../store/store";
import { getAccountKeyForMailboxInfo, type MailboxInfo } from "owa-client-types";
import type { MailboxFolderTreeData } from "../store/schema/FolderStore";

/**
 * Selector for folder tree table for given mailbox smtp identity
 */
export default function getMailboxFolderTreeDataTable(mailboxInfo: MailboxInfo): Map<string, FolderTreeData> | undefined {
    const data = getMailboxFolderTreeData(mailboxInfo);
    if (!data) {
        trace.warn(`getMailboxFolderTreeDataTable Failure:${getStore().mailboxFolderTreeData.size} identities in store`);
    }
    
    return data?.folderTreeTable;
}

export function getMailboxFolderTreeData(mailboxInfo: MailboxInfo): MailboxFolderTreeData | undefined {
    return getStore().mailboxFolderTreeData.get(getAccountKeyForMailboxInfo(mailboxInfo));
}
